import {
  ImageField,
  NextImage,
  withDatasourceCheck,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Container from "@repo/ui/container";
import * as Flex from "@repo/ui/flex";
import { isMobile } from "../../utils";
import styles from "./double-image.module.css";

export type DoubleImageProps = ComponentProps & {
  fields: {
    leftImage?: ImageField;
    rightImage?: ImageField;
  };
};

const DoubleImage = (props: DoubleImageProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (
    !isEditing &&
    !props.fields.leftImage?.value?.src &&
    !props.fields.rightImage?.value?.src
  ) {
    return <></>;
  }

  const mobileView = isMobile();

  return (
    <Container.Root size="medium">
      <Flex.Container column={mobileView!} className={styles.container}>
        <div className={clsx(styles.mediaContainer)}>
          <NextImage
            field={props.fields.leftImage}
            data-testid="jss-image"
            editable
            unoptimized
          />
        </div>
        <div className={clsx(styles.mediaContainer)}>
          <NextImage
            field={props.fields.rightImage}
            data-testid="jss-image"
            editable
            unoptimized
          />
        </div>
      </Flex.Container>
    </Container.Root>
  );
};

export default withDatasourceCheck()<DoubleImageProps>(DoubleImage);
